export default "__VITE_ASSET__mA5glJGm__"